var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "9 9.999 12 10.001"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.5 16h7.985l-2.342 2.42a.52.52 0 0 0 0 .715l.683.717a.47.47 0 0 0 .684 0l4.35-4.507a.53.53 0 0 0 0-.717l-4.323-4.48a.465.465 0 0 0-.683 0l-.684.717a.52.52 0 0 0 0 .715L17.51 14H9.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5"
})));
export default SvgArrowRight;